import {
  Component,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { PostTradeService } from '../../post-trade.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  FormGroup,
  FormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { HashResult } from '../../../models/post-trade-models';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdminService } from '../../../admin/admin.service';

@Component({
  selector: 'app-external-grouping-dialog',
  templateUrl: './external-grouping-dialog.component.html',
  styleUrls: ['./external-grouping-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgxLoadingModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
  ],
})
export class ExternalGroupingDialogComponent implements OnInit, OnDestroy {
  dialogRef =
    inject<MatDialogRef<ExternalGroupingDialogComponent>>(MatDialogRef);
  private ptSvc = inject(PostTradeService);
  private adminService = inject(AdminService);
  private snacky = inject(MatSnackBar);
  private location = inject(Location);
  data = inject(MAT_DIALOG_DATA);

  unsubscribe = new Subject();
  recommendedGroups;
  selectedGroup = '';
  loading = false;
  tableView = true;
  groupForm: FormGroup;
  AccountIDControl = new FormControl<any>('');
  HashedSSNControl = new FormControl<any>('');
  valueHashed = false;
  headers;

  ngOnInit() {
    this.getGridSetup();
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  getGridSetup() {
    this.loading = true;
    this.adminService
      .getUIConfigHeaders({
        uiconfig: 'ag-grids',
        type: 'trades',
        implementation: 'rb',
      })
      .subscribe({
        next: resp => {
          this.headers = resp['headers'];
          if (this.data.externalInitData) {
            const formGroup = {};
            const formKeys = Object.keys(this.data.externalInitData);
            formKeys.map(keyName => {
              formGroup[keyName] = new FormControl();
            });
            this.groupForm = new UntypedFormGroup(formGroup);
          }

          this.getSuggestedGroups(true);
        },
        error: error => {
          console.error('GRID SETUP ERROR: ', error);
          this.loading = false;
        },
      });
  }

  getSuggestedGroups(initialGet?) {
    const queryData = { search: {} };
    if (initialGet) {
      queryData['system'] = true;
      const formKeys = Object.keys(this.data.externalInitData);
      formKeys.map(keyName => {
        if (this.data.externalInitData[keyName]) {
          queryData['search'][keyName] = {
            searchString: this.data.externalInitData[keyName],
          };
        }
      });
    } else {
      const formKeys = Object.keys(this.groupForm['value']);
      formKeys.map(keyName => {
        if (this.groupForm['value'][keyName]) {
          queryData['search'][keyName] = {
            searchString: this.groupForm['value'][keyName],
          };
        }
      });
    }
    this.ptSvc.getAccountGroupingGridData(queryData).subscribe(resp => {
      if (resp['data']) {
        this.recommendedGroups = resp['data'];
      }
      this.loading = false;
    });
  }

  linkAccount() {
    this.ptSvc
      .linkAccount(this.selectedGroup, this.data.externalInitData.AccountID)
      .subscribe({
        next: () => {
          this.snacky.open(`Account Linked!`, 'Close', {
            duration: 3000,
          });
          this.dialogRef.close();
        },
        error: err => {
          this.snacky.open(
            `Whoops something went wrong, please try again later!`,
            'Close',
            {
              duration: 3000,
            }
          );
          console.error(err);
        },
      });
  }

  selectGroup(accountId) {
    if (this.selectedGroup === accountId) {
      this.selectedGroup = '';
    } else {
      this.selectedGroup = accountId;
    }
  }

  viewAccountGroup(group) {
    window.open(
      `${this.location.prepareExternalUrl('')}account-grouping/${
        group.GroupID
      }`,
      '_blank'
    );
  }

  toggleView() {
    if (!this.tableView) {
      this.loading = true;
      this.getSuggestedGroups();
    }
    this.tableView = !this.tableView;
  }

  hashInput(ev, groupField) {
    if (ev.target.value) {
      this.ptSvc
        .getHashString(ev.target.value)
        .subscribe((resp: HashResult) => {
          this.valueHashed = true;
          if (resp.resultString) {
            this.groupForm.controls[groupField].setValue(resp.resultString);
            this[groupField + 'Control'].setValue(resp.resultString);
          }
        });
    } else {
      this.groupForm.controls[groupField].setValue('');
      this[groupField + 'Control'].setValue('');
    }
  }
}
